module.exports = __webpack_public_path__ + "static/media/tks.c5874a66.svg";